import {IWuAppHeaderAccount} from '@/components/appHeader/types/WuAppHeaderAccount'
import {cn} from '@/lib/utils'

export const UserMenuItem: React.FC<{
  user: IWuAppHeaderAccount
  dir?: 'ltr' | 'rtl'
}> = ({user, dir}) => (
  <section
    className={cn('flex gap-2 p-4 w-full', dir === 'rtl' ? 'pr-0' : 'pl-0')}
  >
    <div className="flex items-center justify-center w-12">
      <span className="text-base wm-person"></span>
    </div>
    <div className={cn('flex flex-col gap-1', dir === 'rtl' && 'text-right')}>
      <p>{user?.profile?.title}</p>
      <a
        href={user?.license?.url}
        className="hover:text-blue-p group/license focus:outline-none focus:text-blue-p"
        dir={dir}
      >
        <p>{user?.profile?.subtitle}</p>
        <p className="font-light">{user?.profile?.companyName}</p>
      </a>
      {user?.license && (
        <div className="flex items-center justify-between gap-6 mt-4" dir={dir}>
          <a
            href={user?.license?.url}
            className="hover:text-blue-p group/license focus:outline-none focus:text-blue-p"
          >
            <div className="flex flex-col items-start gap-1">
              <p className="font-normal">{user?.license?.subtitle}</p>
              <button
                tabIndex={-1}
                className="px-3 py-1 border rounded-sm border-gray-subtle group-hover/license:border-blue-p"
              >
                {user?.license?.title}
              </button>
            </div>
          </a>
          <div className="flex flex-col items-start gap-1" dir={dir}>
            <p className="font-normal">
              {user?.license?.expiryDatePostFixString}
            </p>
            <p>{user?.license?.expiryDate}</p>
          </div>
        </div>
      )}
    </div>
  </section>
)
